module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "operations"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (false),
      expression: "false"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "link": "",
      "total": _vm.operationsAmount,
      "noBreackColumns": ['date', 'payment_number', 'ones_id', 'sum'],
      "table-id": "operations"
    },
    on: {
      "refresh": _vm.getOperations,
      "create": _vm.addOperation
    },
    scopedSlots: _vm._u([{
      key: "sum",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.sum ? (_vm.priceFormat(scope.item.sum) + ' руб.') : '0 руб.'))]
      }
    }, {
      key: "company",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.company ? scope.item.company.name : ''))]
      }
    }, {
      key: "customer",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.customer ? scope.item.customer.name : ''))]
      }
    }, {
      key: "type",
      fn: function(scope) {
        return [_c('span', {
          style: ('color: ' + ((scope.item.type == 1) ? '#009688' : '#FF5252'))
        }, [_vm._v(" " + _vm._s((scope.item.type == 1) ? 'Приход' : 'Расход') + " ")])]
      }
    }, {
      key: "date",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(((scope.item.date) ? _vm.moment(scope.item.date).format('DD.MM.YYYY HH:mm:ss') : '')))])]
      }
    }, {
      key: "created_at",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(((scope.item.created_at) ? _vm.moment(scope.item.created_at).format('DD.MM.YYYY HH:mm:ss') : '')))])]
      }
    }, {
      key: "updated_at",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(((scope.item.updated_at) ? _vm.moment(scope.item.updated_at).format('DD.MM.YYYY HH:mm:ss') : '')))])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.operations),
      callback: function($$v) {
        _vm.operations = $$v
      },
      expression: "operations"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebae311e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/finance/views/Operations.vue
// module id = 1273
// module chunks = 0